import { toMerged } from 'es-toolkit';

import { DEFAULT_WIREFRAME_PROPS } from '@/config/defaults';
import {
  CustomGeometryClassDefinition,
  CustomGeometryInstance,
  GeometryInstanceWrapper,
} from '@/features/custom-shared/types/editor/custom';
import {
  GeometryProjectFileWrapper,
  JSONProjectContent,
} from '@/features/custom-shared/types/project';

import { DeepPartial } from '@nablax/shared/types';
import { GeometryClassDefinition } from '../../custom-shared/types/editor/classes';
import {
  GeometryClassInstance,
  GeometryClassInstanceWithDefaults,
} from '../../custom-shared/types/editor/instances';

export function createInstanceWrapper<T extends CustomGeometryInstance>({
  baseName,
  definition,
  json,
}: {
  baseName: string;
  definition: CustomGeometryClassDefinition;
  json: T | null;
}): GeometryInstanceWrapper<T> {
  return {
    baseName,
    withDefaults: mergeGeometryInstance(definition, json),
    original: json,
  } as GeometryInstanceWrapper<T>;
}

export function mergeGeometryInstance(
  definition: GeometryClassDefinition,
  instance: null | GeometryClassInstance,
): GeometryClassInstanceWithDefaults<CustomGeometryInstance> {
  if (!instance) {
    return {
      export: [],
      className: definition.name,
      displayProperties: toMerged(
        { wireframe: DEFAULT_WIREFRAME_PROPS },
        definition.displayProperties,
      ),
      properties: {},
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
  }
  // merge diplayproperties

  return {
    ...instance,
    export: [],
    displayProperties: toMerged(
      toMerged(
        {
          wireframe: DEFAULT_WIREFRAME_PROPS,
        },
        instance.displayProperties,
      ),
      definition.displayProperties,
    ),
  };
}

export function needsUpdatedAt(
  patchContent?: DeepPartial<JSONProjectContent>,
  removeKeys?: string[],
) {
  if (removeKeys && removeKeys.length) {
    return true;
  }

  if (
    patchContent &&
    ('properties' in patchContent || 'classProperties' in patchContent)
  ) {
    return true;
  }

  return false;
}

export function getProjectFileExts(file: GeometryProjectFileWrapper) {
  return Object.entries(file)
    .filter(([_, value]) => !!value)
    .map(([k]) => k);
}
